import Extent from "@arcgis/core/geometry/Extent";

const WIDTH_LV_4 = 750;
const HEIGHT_LV_4 = -600;
const WIDTH_LV_2 = WIDTH_LV_4 * 2 * 5;
const HEIGHT_LV_2 = HEIGHT_LV_4 * 2 * 5;

const oX = 800000;
const oY = 848000;

const ORIENT_NAME = [["NW", "NE"], ["SW", "SE"]];
const MapSheet = {};

for (let y1 = 0; y1 < 4; y1++) {
  for (let x1 = 0; x1 < 4; x1++) {
    for (let y2 = 0; y2 < 2; y2++) {
      for (let x2 = 0; x2 < 2; x2++) {
        let xmin = oX + WIDTH_LV_2 * (x1 * 2 + x2);
        let ymax = oY + HEIGHT_LV_2 * (y1 * 2 + y2);
        let xmax = xmin + WIDTH_LV_2;
        let ymin = ymax + HEIGHT_LV_2;
        MapSheet[4 * y1 + (x1 + 1) + ORIENT_NAME[y2][x2]] = new Extent({
          xmin,
          ymax,
          xmax,
          ymin,
          spatialReference: { wkid: 2326 },
        });
      }
    }
  }
}

const MapSheetKeys = Object.keys(MapSheet);
const MapSheetValues = Object.values(MapSheet);

const classObj = {
  ...MapSheet,
  some: function(extent) {
    return MapSheetValues.some((i) => i.intersects(extent));
  },
  filter: function(extent) {
    return MapSheetValues.filter((i) => i.intersects(extent));
  },
  filterKey: function(extent) {
    return MapSheetKeys.filter((i) => MapSheet[i].intersects(extent));
  },
};

console.debug(classObj);

export default classObj;
